import type { Etablissement } from '@/models/types';

export const getEtablissementLabel = (
  etablissement: Pick<Etablissement, 'name' | 'finess'> | null,
) => {
  if (!etablissement) {
    return '';
  }
  let label = etablissement.name ?? '';
  if (etablissement.finess) {
    label += ` (${etablissement.finess})`;
  }

  return label;
};
